var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.84521C17 9.61111 16.8111 9.42488 16.5788 9.42488H14.4319C14.1996 9.42488 14.0107 9.61111 14.0107 9.84521C14.0107 12.6926 11.6918 15.0116 8.84344 15.0116C5.99512 15.0116 3.6762 12.6926 3.6762 9.84521C3.6762 6.99512 5.99423 4.67886 8.84344 4.67886C9.14494 4.67886 9.44645 4.70369 9.7444 4.75778V6.2183C9.7444 6.38945 9.84727 6.54375 10.0025 6.6076C10.163 6.67233 10.3421 6.63509 10.4645 6.51537L14.7494 3.61296C14.9125 3.4489 14.9125 3.18553 14.7494 3.02148L10.4636 0.123497C10.343 0.00289514 10.1638 -0.0325758 10.0033 0.031272C9.84816 0.0968933 9.74529 0.249419 9.74529 0.41968V1.73831C9.44379 1.70462 9.14228 1.68777 8.84433 1.68777C4.34749 1.68777 0.687769 5.34749 0.687769 9.84433C0.687769 14.3403 4.34749 18 8.84433 18C13.3403 18.0009 17 14.3412 17 9.84521Z",
    fill: "#556BB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshBlue);
export default __webpack_public_path__ + "static/media/refresh-blue.5bfb2867f9b67bcc310db35bcb3dc515.svg";
export { ForwardRef as ReactComponent };